<template>
  <basic-container>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="临停订单" name="first">
          <tempcarBill ref="tempcarBill"/>
        </el-tab-pane>
        <el-tab-pane label="月卡车缴费记录" name="second">
          <monthcarLog ref="monthcarLog"/>
        </el-tab-pane>
        <el-tab-pane label="固停车缴费记录" name="third">
          <fixedcarLog ref="fixedcarLog"/>
        </el-tab-pane>
        <el-tab-pane label="储值车充值记录" name="fourth">
          <chargefeeLog ref="chargefeeLog"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </basic-container>
</template>

<script>
import tempcarBill from '@/views/v4ward/car/tempcarbill-';
import monthcarLog from '@/views/v4ward/park/paylog/monthcar-log';
import chargefeeLog from '@/views/v4ward/park/paylog/chargefee-log';
import fixedcarLog from '@/views/v4ward/park/paylog/fixedcar-log';
import {
  getManagefeedetailList
} from '@/api/v4ward/park/vehiclev3/parkvehicle';


export default {
        components:{
                tempcarBill,monthcarLog,chargefeeLog,fixedcarLog
        },
  data() {
      return {
        activeName: 'first',
        manageFeedetailList:[],
      };
    },
    mounted(){
      getManagefeedetailList({carManageType:1}).then(res=>{
        this.manageFeedetailList = res.data;
        console.log("getManagefeedetailList============>",res.data);
      });
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
        console.log(this.$refs);
        this.$refs.fixedcarLog.doLayoutHandler();
        this.$refs.chargefeeLog.doLayoutHandler();
        this.$refs.monthcarLog.doLayoutHandler();
      }
    }
}
</script>

<style scoped>
/* 
::v-deep .avue-form__menu--center {
    text-align: right;
} */
</style>